<template>
  <div data-grm-comp="RoomCBTTimer" class="w-32 bg-blue-400 flex justify-center">
    <div class="py-2 text-white text-2xl">{{ remainingTime }}</div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import dayjs from "dayjs";

export default {
  name: 'RoomCBTTimer',
  components: {
  },
  data() {
    return {
      diffSeconds: 0,
      remainingSeconds: 0,
      remainingTime: '00:00:00',
    }
  },
  computed: {
    ...mapState('cbt', [
      'roomCBT',
    ]),
    ...mapGetters('user', [
      'me',
      'hasEmceeRole',
    ]),
  },
  watch: {
    'roomCBT.duration': {
      handler(duration) {
        if (!duration) {
          return;
        }

        this.setTimeSeconds(duration);
        this.setDuration(duration);
        this.startTimer(duration);
      },
      deep: true,
      immediate: true,
    }
  },
  destroyed() {
    clearTimeout(this._startTimer);
  },
  methods: {
    ...mapActions('cbt', [
      'endRoomCBT',
    ]),
    ...mapMutations('cbt', [
      'COMPLETE_ROOM_CBT_USER',
    ]),

    setTimeSeconds(duration) {
      const now = Date.now();
      const beginDate = new Date(this.roomCBT.beginDate).getTime();
      console.log('## init Start Timer now[%s] beginDate[%s]', now, beginDate);
      this.diffSeconds = Math.floor((now - beginDate) / 1000);
      if (this.diffSeconds <= 0) {
        this.diffSeconds = 0;
      }
      this.remainingSeconds = duration;
    },
    setDuration(duration) {
      this.remainingSeconds = this.remainingSeconds > 0 ? duration - this.diffSeconds : duration + this.diffSeconds;
      this.remainingTime = new Date(this.remainingSeconds * 1000).toISOString().substr(11, 8);
    },
    startTimer(duration) {
      this._startTimer = setTimeout(() => {
        duration -= 1;

        this.setDuration(duration);
        this.startTimer(duration);

        if (this.remainingSeconds <= 0) {
          clearTimeout(this._startTimer);

          if (this.hasEmceeRole()) {
            this.$alert(this.$t('testBank.alert.end.emcee'), () => {
              this.endRoomCBT({
                roomCbtId: this.roomCBT.roomCbtId,
              });
            });
          } else {
            this.COMPLETE_ROOM_CBT_USER({
              roomCbtUser: {
                userId: this.me.userId,
                endDate: dayjs(new Date()).toISOString(),
                endType: 'TIMEOUT',
              }
            });
            this.$alert(this.$t('testBank.alert.end.participant'));
          }
        }
      }, 1000);
    },
  }
}
</script>